export default [
  {
    path: '/apps/regra/list',
    name: 'apps-regra-list',
    component: () => import('@/views/app/regras/list/Index.vue'),
    meta: {
      pageTitle: 'Regras',
      adminDkpOnly: true,
    },
  },
];
